import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import {
  BrowserRouter,
  useRoutes
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { Analytics } from '@vercel/analytics/react'

import routes from './router'

const queryClient = new QueryClient()

export function App () {
  const content = useRoutes(routes)
  return content
}

export function WrappedApp () {
  if (process.env.NODE_ENV !== 'development') {
    Sentry.init({
      dsn: 'https://e909ce1a6d264a7abe583ca7ebccabaf@o4505590441508864.ingest.sentry.io/4505590443147264',
      integrations: [
        new Sentry.BrowserTracing({
          // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: ['localhost', 'https://laboratorio-backend-production.up.railway.app', 'https://laboratorio-frontend-jovrf.ondigitalocean.app']
        }),
        new Sentry.Replay()
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  }

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        <Analytics/>
      </QueryClientProvider>
    </BrowserRouter>
  )
}
